import { WarehouseComponent } from 'src/app/content/componentes/warehouse/warehouse.component';
import { Warehouse } from 'src/app/models/warehouse';

export class ConfirmDialog {
    title: string;
    message: string = "-";
    labelCancel : string = "Cancel";
    labelOk : string = "Ok";
    fnOK : object;
    flagRespuesta : boolean=false;
    img: string;
    doc:string;
    wr:Warehouse;
  }